import { Forms } from "./forms"
import { flipCard } from "./flip-card"


window.GetHooked = {}

const afterLoad = () => {
    // Initialize conversational form
    flipCard.init()
    Forms.init()
}

document.addEventListener('DOMContentLoaded', afterLoad)